import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function MachineryOwnerContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  machineryOwnerId,
  getSingleMachineryOwner,
  machineryOwnerInfo,
  dataList,
  isListingLoading,
  permissions,
}) {
  useEffect(() => {
    if (_.isEmpty(machineryOwnerId)) return;
    getSingleMachineryOwner(machineryOwnerId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(machineryOwnerId)) return;
    getSingleMachineryOwner(machineryOwnerId);
  }, [machineryOwnerId]);

  return (
    <div className="d-flex flex-column h-100">
      {Acl(permissions, ['CREATE E2E RPT MACHINERY OWNERS']) && (
        <div className="row mb-3">
          <div className="ml-auto">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
              style={{ marginRight: 30 }}
            >
              <i className="fas fa-plus" />
              <span className="ml-2">Add Machinery Owner</span>
            </button>
          </div>
        </div>
      )}
      <div className="ml-3 p-3 card right-section h-100">
        {!_.isEmpty(machineryOwnerInfo) &&
        !_.isEmpty(dataList) &&
        !isListingLoading ? (
          <>
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-10">
                <h3 className="">Information</h3>
              </div>
              <div className="col-2 d-flex align-items-end justify-content-end">
                {Acl(permissions, ['UPDATE E2E RPT MACHINERY OWNERS']) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(machineryOwnerInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                )}
                {Acl(permissions, ['DELETE E2E RPT MACHINERY OWNERS']) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(machineryOwnerInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                )}
              </div>
            </div>
            <hr className="my-4" />
            <div className="mt-1">
              <div className="row d-flex">
                <div className="col-12">
                  <table className="transaction-table table table-borderless table-striped table-sm ">
                    <tbody>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Name
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(machineryOwnerInfo, 'attributes.full_name') ||
                            '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Status
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(machineryOwnerInfo, 'attributes.status') ||
                            '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Address
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(
                            machineryOwnerInfo,
                            'attributes.full_address'
                          ) || '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Tax Identification Number (TIN)
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(machineryOwnerInfo, 'attributes.tin') || '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Telephone No.
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(
                            machineryOwnerInfo,
                            'attributes.telephone_no'
                          ) || '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Mobile No.
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(
                            machineryOwnerInfo,
                            'attributes.mobile_number'
                          ) || '--'}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="span-title2 font-weight-bold"
                          width="250"
                        >
                          Email Address
                        </td>
                        <td className="text-dark" width="1" />
                        <td className="text-dark">
                          {_.get(machineryOwnerInfo, 'attributes.email') ||
                            '--'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MachineryOwnerContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  machineryOwnerInfo: PropTypes.instanceOf(Object).isRequired,
  machineryOwnerId: PropTypes.string.isRequired,
  isListingLoading: PropTypes.bool.isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  machineryOwnerInfo: _.get(api, `${c.GET_SINGLE_MACHINERY_OWNER}.item`) || {},
  machineryOwnerId: _.get(match, 'params.machineryOwnerId') || '',
  isListingLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_OWNER) > -1,
  dataList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryOwnerContent);
